import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FromPremio = ({ fechaModal, premio_id}) => {
  //valores iniciais do formulario
  const inicialForm = {
    premio_id: premio_id,
    premio: '',
    num_pontos: '',
    saldo: ''
  }

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)

  //preenche setform e formulario
  const editPremio = (premio_id) => {
    const url = rotas.premio+premio_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success) {
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(premio_id != ''){
      editPremio(premio_id)
    }else{
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault();

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.premio+'gravar.php'
        if(premio_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editPremio(premio_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
          })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editPremio(ret.retorno.insert_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
          })
        }
      }

    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="premio_id">Prêmio</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name        = "premio_id"
                    id          = "premio_id"
                    value       = {form.premio_id}
                    onChange    = {onChange('premio_id')}
                  />
                </FormGroup>
              </Col>

              <Col md='6'>
                <FormGroup>
                  <Label for="premio">Prêmio</Label>
                  <Input
                    required
                    name        = "premio"
                    id          = "premio"
                    placeholder = "Informe o nome do produto"
                    value       = {form.premio}
                    onChange    = {onChange('premio')}
                  />
                </FormGroup>
              </Col>

              <Col md='2'>
                <FormGroup>
                  <Label for="pontos">Pontos Necessários</Label>
                  <Input
                    required
                    name        = "pontos"
                    id          = "pontos"
                    placeholder = "Pontos"
                    value       = {form.num_pontos}
                    onChange    = {onChange('num_pontos')}
                  />
                </FormGroup>
              </Col>

              <Col md='2'>
                <FormGroup>
                  <Label for="saldo">saldo</Label>
                  <Input
                    required
                    name        = "saldo"
                    id          = "saldo"
                    placeholder = "Saldo do produto"
                    value       = {form.saldo}
                    onChange    = {onChange('saldo')}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
      </>
    )
  }

}

export default FromPremio
